var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenTypeScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "52px",
    viewBox: "0 0 28 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7B22821F-3778-4C14-8311-A905E8F70DC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-463.000000, -4586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    transform: "translate(464.000000, 4587.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 26,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.500000, 5.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.67361738e-17,
    y1: 39.5,
    x2: 25,
    y2: 39.5,
    id: "Line-2",
    stroke: "#EEEEEE",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.67361738e-17,
    y1: 0.5,
    x2: 25,
    y2: 0.5,
    id: "Line-2-Copy-6",
    stroke: "#EEEEEE",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#EEEEEE",
    x: 1.5,
    y: 4,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    fill: "#EEEEEE",
    x: 1.5,
    y: 10,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-66",
    fill: "#EEEEEE",
    x: 1.5,
    y: 16,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    fill: "#464646",
    x: 1.5,
    y: 24,
    width: 22,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(3.500000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#464646",
    x: 0,
    y: 0,
    width: 2.5,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-49",
    fill: "#EEEEEE",
    x: 5.33333333,
    y: 0,
    width: 2.5,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-51",
    fill: "#EEEEEE",
    x: 10.6666667,
    y: 0,
    width: 2.5,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-50",
    fill: "#EEEEEE",
    x: 16,
    y: 0,
    width: 2.5,
    height: 2.5,
    rx: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenTypeScreen);
export default __webpack_public_path__ + "static/media/ScreenType-Screen.e7caedc3f1cedf0729fb19802ba7a21d.svg";
export { ForwardRef as ReactComponent };